import { render } from "./Biography.vue?vue&type=template&id=144308dc&scoped=true"
import script from "./Biography.vue?vue&type=script&lang=js"
export * from "./Biography.vue?vue&type=script&lang=js"

import "./Biography.vue?vue&type=style&index=0&id=144308dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-144308dc"

export default script